function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Broadband(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.837 10.998a1 1 0 011 1l-.001.933h12.247c1.103 0 2 .897 2 2v5.662c0 1.103-.897 2-2 2H3.013c-1.103 0-2-.897-2-2v-5.662c0-1.103.897-2 2-2h3.823v-.933a1 1 0 011-1zm13.246 3.933H3.013v5.662h18.07v-5.662zm-6.518 1.603a1.25 1.25 0 11-.001 2.501 1.25 1.25 0 010-2.5zm3.583 0a1.25 1.25 0 110 2.501 1.25 1.25 0 010-2.5zM7.836 7.868c1.228 0 2.391.537 3.19 1.471a1 1 0 01-1.52 1.3c-.827-.967-2.466-.982-3.309-.034a.999.999 0 11-1.495-1.328 4.197 4.197 0 013.134-1.409zm0-2.933c1.81 0 3.538.68 4.863 1.92a1 1 0 11-1.366 1.46 5.119 5.119 0 00-6.952-.038A.998.998 0 113.033 6.8a7.102 7.102 0 014.804-1.866zM7.838 2c2.397 0 4.722.86 6.544 2.425a.999.999 0 11-1.301 1.518A8.06 8.06 0 007.837 4a8.065 8.065 0 00-5.192 1.899 1 1 0 01-1.29-1.528A10.061 10.061 0 017.837 2z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
const MemoBroadband = /*#__PURE__*/React.memo(Broadband);
export default MemoBroadband;